import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Button, Col, Row } from 'react-bootstrap';
import Loading from '../../../components/Loading';
import { useToast } from '../../../hooks/toast';
import api from '../../../services/api';
import getResponseErrors from '../../../utils/getResponseErrors';
import getValidationErrors from '../../../utils/getValidationErrors';
import { useAuth } from '../../../hooks/auth';
import TextArea from '../../../components/TextArea';
import { IPedidoEspecialidade } from '.';
import Input from '../../../components/Input';
import { usePerfil } from '../../../hooks/perfil';
import SelectSync from '../../../components/SelectSync';
import { TIPO_PERFIL } from '../../../utils/funcoes';

// import { Container } from './styles';
interface IFormBusca {
  exames: string;
  PedEspecialidade: string;
  PedIndicacao: string;
  PedCid: string;
  PedHistorico: string;
  outrasEspecialidades: string;
}

interface ICreatePedidoEspecialidadeDTO {
  PedMedUsuCodigo: number;
  PedPacCodigo: number;
  PedPerCodigo: number;
  PedAgeCodigo: number;
  PedCliCodigo: number;
  PedIndicacao: string;
  PedEspecialidade: string;
  PedHistorico: string;
  PedCid: string;
}

interface IOption {
  value: string;
  label: string;
}

type PacienteProps = {
  pacCodigo: number;
  ageCodigo: number;
  cliCodigo: number;
  handleDadosSalvos(dados: IPedidoEspecialidade): void;
};

const PedidoEspecialidadeCadastro: React.FC<PacienteProps> = ({
  pacCodigo,
  ageCodigo,
  cliCodigo,
  handleDadosSalvos,
}) => {
  const { addToast } = useToast();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const formRefBusca = useRef<FormHandles>(null);
  const [exibeOutrasEspecialidades, setExibeOutrasEspecialidades] = useState(
    false,
  );
  const [perfilSelecionado, SetPerfilSelecionado] = useState<
    IOption | undefined
  >(undefined);
  const [perfisMedicos, setPerfisMedicos] = useState<IOption[]>([]);

  const { perfis, buscaPerfil } = usePerfil();

  useEffect(() => {
    async function loadPerfis(): Promise<void> {
      await buscaPerfil();
    }
    if (!perfis || Object.keys(perfis).length === 0) loadPerfis();
  }, [buscaPerfil, perfis]);

  useEffect(() => {
    if (!perfis || !perfis.perfis || perfis.perfis.length === 0) return;
    try {
      const outrasEspecialidades = {
        value: 'outrosxxx',
        label: 'Outras Especialidades...',
      };
      const perfisOk = perfis.perfis
        .filter(per => per.PerAtivo && per.PerTipo === TIPO_PERFIL.CONSULTA)
        .map(per => {
          return { value: per.PerCodigo.toString(), label: per.PerNome };
        })
        .concat(outrasEspecialidades);

      perfisOk.unshift(outrasEspecialidades);

      setPerfisMedicos(perfisOk);
    } catch (error) {
      addToast({
        title: 'Não foi possível buscar perfisMedicos',
        type: 'error',
      });
    }
  }, [addToast, perfis]);

  const handleSalvar = useCallback(
    async (dados: IFormBusca) => {
      setLoading(true);
      try {
        formRefBusca.current?.setErrors({});

        if (!perfilSelecionado && !dados.outrasEspecialidades) {
          throw new Error('Selecione uma especialidade');
        }

        const dadosExame: ICreatePedidoEspecialidadeDTO = {
          PedMedUsuCodigo: user.UsuCodigo,
          PedPacCodigo: pacCodigo,
          PedAgeCodigo: ageCodigo,
          PedCliCodigo: cliCodigo,
          PedIndicacao: dados.PedIndicacao.toUpperCase(),
          PedEspecialidade:
            perfilSelecionado?.label ||
            dados.outrasEspecialidades ||
            'Não selecionou',
          PedPerCodigo: perfilSelecionado?.value
            ? Number(perfilSelecionado.value)
            : 0,
          PedCid: dados.PedCid,
          PedHistorico: dados.PedHistorico,
        };

        const response = await api.post<IPedidoEspecialidade>(
          `/pedidoEspecialidade`,
          dadosExame,
        );

        handleDadosSalvos(response.data);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRefBusca.current?.setErrors(errors);
        }
        const mensagem = getResponseErrors(error);
        addToast({
          title: 'Não foi possível salvar dados',
          type: 'error',
          description: mensagem,
        });
      } finally {
        setLoading(false);
      }
    },
    [
      perfilSelecionado,
      user.UsuCodigo,
      pacCodigo,
      ageCodigo,
      cliCodigo,
      handleDadosSalvos,
      addToast,
    ],
  );

  const handleOnChangeVazio = useCallback((dados: IOption) => {
    if (dados.value === 'outrosxxx') {
      SetPerfilSelecionado(undefined);
      setExibeOutrasEspecialidades(true);
      return;
    }
    SetPerfilSelecionado(dados);
    setExibeOutrasEspecialidades(false);
  }, []);

  return (
    <>
      {loading && <Loading backgroundBlack={false} />}

      <div className="container">
        <>
          <br />
          <h4> Pedido de Encaminhamento</h4>
          <p>
            Preencha os dados abaixo para encaminhar o paciente a outra
            especialidade.
          </p>
          <Form
            ref={formRefBusca}
            initialData={{ exames: '', PedIndicacao: '' }}
            onSubmit={handleSalvar}
          >
            <Row>
              <Col md={12} className="mb-1">
                <SelectSync
                  name="especialidade2"
                  label="Especialidade de Destino"
                  placeholder="Procurar"
                  isClearable
                  handleSelectChange={handleOnChangeVazio}
                  options={perfisMedicos}
                />

                {/* <SelectAsync
                  urlApi="perfis/combo?PerAtivo=1&PerNome="
                  name="especialidade"
                  label="Especialidade de Destino"
                  placeholder="Procurar"
                  isClearable={false}
                  handleSelectChange={dados => SetPerfilSelecionado(dados)}
                /> */}

                {exibeOutrasEspecialidades && (
                  <div
                    className="my-1 flex flex-col gap-2 rounded-lg p-3"
                    style={{
                      backgroundColor: '#e9f7fc',
                      border: '1px #5A9BB0 dashed',
                    }}
                  >
                    <Input
                      name="outrasEspecialidades"
                      label="Informe a especialidade"
                      placeholder="Ex.: Neurologista, Medicina do Esporte, etc."
                    />
                  </div>
                )}
              </Col>
              {/* <Col md={4}>
                <Button
                  type="button"
                  onClick={() => setExibeOutrasEspecialidades(true)}
                >
                  Outras Especialidade
                </Button>
              </Col> */}
              <Col md={12}>
                <TextArea
                  name="PedIndicacao"
                  label="Motivo / Indicação Clínica"
                  placeholder="Descreva o motivo do encaminhamento, historico relevante, exames realizados e suspeita diagnostica..."
                  maxLength={150}
                  rows={4}
                />
                <p className="text-xs text-muted-foreground">
                  Inclua informacoes clinicas relevantes para o especialista de
                  destino.
                </p>
              </Col>
            </Row>
          </Form>
          <Row>
            <Col md={12}>
              <div className="d-flex justify-content-between mt-2">
                <Button
                  type="button"
                  onClick={() => formRefBusca?.current?.submitForm()}
                  size="sm"
                  variant="success"
                >
                  Salvar dados
                </Button>
              </div>
            </Col>
          </Row>
        </>
      </div>
    </>
  );
};

export default PedidoEspecialidadeCadastro;
